import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { apiError } from "@/lib/championships";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { Modal } from "@/components/ui/Modal";
import { PlayerPicker, type PlayerRef } from "@/components/championships/PlayerPicker";

// Alta de una pareja. La edición de una pareja ya inscrita vive en su propia ficha
// (/campeonatos/:id/equipos/:equipoId).
export function TeamFormModal({ championshipId, onOpenChange }: { championshipId: number; onOpenChange: (open: boolean) => void }) {
  const queryClient = useQueryClient();
  const [nombre, setNombre] = useState("");
  const [j1, setJ1] = useState<PlayerRef>(null);
  const [j2, setJ2] = useState<PlayerRef>(null);

  const save = useMutation({
    mutationFn: () => api.post(`/championships/${championshipId}/equipos`, { nombre: nombre.trim() || null, jugador1: j1, jugador2: j2 }),
    onSuccess: () => {
      toast.success("Pareja inscrita");
      queryClient.invalidateQueries({ queryKey: ["championship", championshipId] });
      queryClient.invalidateQueries({ queryKey: ["championships"] });
      onOpenChange(false);
    },
    onError: (error) => toast.error(apiError(error, "No se pudo inscribir la pareja")),
  });

  return (
    <Modal open onOpenChange={onOpenChange} size="lg" title="Inscribir pareja" description="Elige dos jugadores existentes o da de alta uno nuevo en el club que corresponda.">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (!j1 || !j2) {
            toast.error("Indica los dos jugadores de la pareja");
            return;
          }
          save.mutate();
        }}
        className="flex flex-col gap-4"
      >
        <Input
          label="Nombre de la pareja (opcional)"
          placeholder="Si lo dejas vacío se muestra «Jugador 1 / Jugador 2»"
          value={nombre}
          onChange={(e) => setNombre(e.target.value)}
          className="w-full"
        />
        <PlayerPicker label="Jugador 1" championshipId={championshipId} onChange={setJ1} />
        <PlayerPicker label="Jugador 2" championshipId={championshipId} onChange={setJ2} />
        <div className="flex flex-wrap justify-end gap-2">
          <Button type="button" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button type="submit" disabled={save.isPending}>
            Inscribir pareja
          </Button>
        </div>
      </form>
    </Modal>
  );
}
